/**
 * O CSV da série temporal do dashboard, montado como função pura.
 *
 * **Dialeto: `;` como separador e VÍRGULA como decimal.** É o que o Excel
 * em português abre certo. O arquivo anterior gravava o número cru do JS,
 * com PONTO decimal e todas as casas (`6.2085714285714203`), e o Excel
 * pt-BR lê o ponto como separador de milhar: a célula aparecia como
 * `6.208.571.428.571.420`. Daí a formatação à mão aqui, sem
 * `toLocaleString` — o resultado não pode depender do idioma do navegador
 * de quem exporta.
 *
 * Casas fixas: CENA com UMA casa (as mesmas de `formatCena`, pra o arquivo
 * bater com o que a pessoa vê na tela) e Valoração com duas (centavos).
 * Os inteiros (menções, alcance, interações) saem como estão.
 *
 * Ausente (`null`/`undefined`) sai como célula VAZIA, nunca `0`: zero na
 * valoração viraria "vale zero reais", e na nota viraria "nota zero".
 *
 * O BOM UTF-8 (`CSV_BOM`) NÃO está no texto devolvido: quem monta o Blob
 * o antepõe, pra o Excel reconhecer os acentos.
 */

import type { DashboardTimelinePoint } from "@/shared/api/api-client";

export const CSV_BOM = "﻿";

const CENA_DECIMALS = 1;
const AD_VALUE_DECIMALS = 2;

function decimalComma(value: number | null | undefined, decimals: number): string {
  return value == null ? "" : value.toFixed(decimals).replace(".", ",");
}

export function buildTimelineCsv(points: DashboardTimelinePoint[], showsCena: boolean): string {
  const header = [
    "Período", "Menções", "Alcance", "Interações", "Valoração (R$)",
    ...(showsCena ? ["CENA"] : [])
  ];
  const rows = points.map(item => [
    item.label,
    item.mentions,
    item.reach,
    item.interactions,
    decimalComma(item.total_ad_value, AD_VALUE_DECIMALS),
    ...(showsCena ? [decimalComma(item.average_cena, CENA_DECIMALS)] : [])
  ]);
  return [header, ...rows]
    .map(row => row.map(value => `"${String(value).replaceAll('"', '""')}"`).join(";"))
    .join("\n");
}
